module.exports = __webpack_public_path__ + "03_bob_yellow.f583840b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_bob_yellow.png
// module id = x6j9
// module chunks = 0